module.exports = __webpack_public_path__ + "static/bc52e7d5c78fb6977a246d00b56e4d19b23f45e12be501d77d872cbd6bebf52e-e99274b82eec92638671b033027fbcc3.jpeg";